import produce from 'immer';
import { ILoadMoreResponse, IWithdrawApplication } from './actions';
import { IAuditionInitialState, IManageAuditionParams, types } from './types';
import { IApplication } from '../../types/global/ListRender.types';
import { parseAuditions, parseSavedItems } from '../../utils/responseProcessor';
import { restoreInitialState } from '../../utils/AppUtils';
import { isEmpty } from '../../utils/lodash';
import _ from 'lodash';
import { IAudition } from '../../types/global/helper';
import { normalizeCastingDirectorList, normalizeCastingDirectorRecord } from '../../utils/castingDirectorNormalize';

const initialState: IAuditionInitialState = {
    gettingAuditions: false,
    gettingAudtionDetails: false,
    gettingAuditionError: null,
    applications: [],
    withdrawingApplication: false,
    withdrawApplicationError: null,
    gettingMyApplications: false,
    gettingMyApplicationsErrorMsg: null,
    auditions: [],
    filterMode: false,
    showFilter: false,
    savedRoles: [],
    savedAuditions: [],
    savedContests: [],
    similarAuditions: [],
    gettingSavedRoles: false,
    savingRole: false,
    gettingSavedRolesError: null,
    savingRoleErrorMsg: null,
    deletingSavedCollection: false,
    updatingSavedCollection: false,
    userAuditions: [],
    gettingUserAuditions: false,
    creatingAuditionMode: false,
    currentAuditionInCreation: { id: '', roles: [] },
    currentAuditionRolesInCreation: [],
    creatingAuditionError: null,
    creatingRolesError: null,
    creatingInProcess: false,
    unPublishing: false,
    deletingAudition: false,
    deletingAuditionErrorMsg: null,
    uploadProgress: '',
    currentManagedApplications: [],
    gettingAuditionApplications: false,
    sortingApplication: false,
    sorter: {
        invited: [],
        unfiled: [],
        yes: [],
        no: [],
        cast: [],
        archived: [],
    },
    searchResults: [],
    currentAuditionPage: 1,
    currentAuditionLimit: 5,
    loadingMore: false,
    loadingMoreErr: null,
    castingDirector: [],
    totalResult: 0,
    managedAuditionWithSubmissions: null,
    managingAuditionWithSubmissions: false,
    managingAuditionWithSubmissionsError: null,
    managedAuditionPagination: {
        total: 0,
        page: 1,
        limit: 9,
        pages: 0,
    },
    searching: false,
    pendingBrandCuratedInviteUserIds: [],
};

const reducer = (state = initialState, action: any) => {
    const { type, payload } = action;

    switch (type) {
        case types.GET_ALL_AUDITIONS:
        case types.ADVANCED_AUDITION_SEARCH:
            return produce(state, (draftState: any) => {
                draftState.gettingAuditions = true;
                // TODO: Check this
                draftState.auditionFilters = undefined;
            });
        case types.FILTER_AUDITION:
            return produce(state, (draftState: any) => {
                draftState.gettingAuditions = true;
            });
        case types.GET_ALL_AUDITION_SUCCESS:
            return produce(state, draftState => {
                const { data } = payload.data;
                const { totalCount, currentPage, pageSize, results } = payload;
                if (currentPage < 2) {
                    draftState.auditions = data;
                } else {
                    draftState.auditions = [...draftState.auditions, ...data];
                }

                draftState.currentAuditionLimit = Number(pageSize);
                draftState.currentAuditionPage = Number(currentPage);
                draftState.gettingAuditions = false;
                draftState.totalResult = totalCount;
                draftState.canLoadMore = results >= pageSize;
            });
        case types.FILTER_AUDITION_SUCCESS:
            return produce(state, draftState => {
                const { data, pagination } = payload;
                const { totalCount, limit, page } = pagination;
                if (page < 2) {
                    draftState.auditions = data;
                } else {
                    draftState.auditions = [...draftState.auditions, ...data];
                }

                draftState.currentAuditionLimit = Number(limit);
                draftState.currentAuditionPage = Number(page);
                draftState.gettingAuditions = false;
                draftState.totalResult = totalCount;
                draftState.canLoadMore = totalCount >= limit;
            });
        case types.ADVANCED_AUDITION_SEARCH_SUCCESS:
            return produce(state, draftState => {
                draftState.searchResults = payload;
                draftState.gettingAuditions = false;
            });
        case types.GET_ALL_AUDITION_FAILED:
        case types.ADVANCED_AUDITION_SEARCH_FAIL:
        case types.FILTER_AUDITION_FAIL:
            return produce(state, (draftState: any) => {
                draftState.gettingAuditionError = payload;
                draftState.gettingAuditions = false;
                draftState.currentAuditionLimit = 5;
                draftState.currentAuditionPage = 1;
            });
        case types.GET_AUDITION_DETAIL:
            return produce(state, (draftState: any) => {
                draftState.gettingAudtionDetails = true;
                draftState.auditionDetails = undefined;
            });
        case types.GET_AUDITION_DETAIL_SUCCESS:
            return produce(state, (draftState: any) => {
                draftState.auditionDetails = payload;
                draftState.gettingAudtionDetails = false;
            });
        case types.GET_AUDITION_DETAIL_FAILED:
            return produce(state, (draftState: any) => {
                draftState.gettingAuditionError = payload;
                draftState.gettingAudtionDetails = false;
            });
        case types.SET_AUDITION:
            return produce(state, (draftState: any) => {
                draftState.auditionDetails = payload;
            });
        case types.GET_ROLES:
            return produce(state, (draftState: any) => {
                draftState.auditionDetails.gettingAuditionRoles = true;
            });
        case types.GET_ROLES_SUCCESS:
            return produce(state, (draftState: any) => {
                draftState.auditionDetails.roles = payload;
                draftState.auditionDetails.gettingAuditionRoles = false;
            });
        case types.GET_ROLES_FAILED:
            return produce(state, (draftState: any) => {
                draftState.auditionDetails.gettingAuditionRolesErrorMsg = payload;
                draftState.auditionDetails.gettingAuditionRoles = false;
            });
        case types.GET_MY_APPLICATIONS:
            return produce(state, (draftState: any) => {
                draftState.gettingMyApplications = true;
            });
        case types.GET_MY_APPLICATIONS_SUCCESS:
            return produce(state, (draftState: any) => {
                draftState.gettingMyApplications = false;
                draftState.applications = payload;
            });
        case types.GET_MY_APPLICATIONS_FAILED:
            return produce(state, (draftState: any) => {
                draftState.gettingMyApplications = false;
                draftState.gettingMyApplicationsErrorMsg = payload;
            });
        case types.TOGGLE_FILTER:
            return produce(state, (draftState: any) => {
                draftState.showFilter = !state.showFilter;
            });
        case types.ADD_FILTER:
            return produce(state, (draftState: any) => {
                draftState.auditionFilters = payload;
                draftState.filterMode = true;
            });
        case types.REMOVE_FILTER:
            return produce(state, draftState => {
                draftState.auditionFilters = undefined;
                draftState.filterMode = false;
            });
        case types.GET_SAVED_COLLECTION:
            return produce(state, (draftState: any) => {
                draftState.gettingSavedRoles = true;
            });
        case types.GET_SAVED_COLLECTION_SUCCESS:
            return produce(state, (draftState: typeof initialState) => {
                draftState.gettingSavedRoles = false;
                const { audition, role, contest } = parseSavedItems(payload);
                draftState.savedRoles = role;
                draftState.savedAuditions = audition;
                draftState.savedContests = contest;
            });
        case types.GET_SAVED_COLLECTION_FAIL:
            return produce(state, (draftState: any) => {
                draftState.gettingSavedRoles = false;
                draftState.gettingSavedRolesError = payload;
            });
        case types.SAVE_COLLECTION:
            return produce(state, (draftState: typeof initialState) => {
                draftState.savingRole = true;
            });
        case types.SAVE_COLLECTION_SUCCESS:
            return produce(state, (draftState: any) => {
                draftState.savingRole = false;
            });
        case types.SAVE_COLLECTION_FAIL:
            return produce(state, (draftState: any) => {
                draftState.savingRole = false;
                draftState.savingRoleErrorMsg = payload;
            });
        case types.DELETE_SAVED_COLLECTION:
            return produce(state, (draftState: any) => {
                draftState.deletingSavedCollection = true;
            });
        case types.DELETE_SAVED_COLLECTION_SUCCESS:
            return produce(state, (draftState: typeof initialState) => {
                draftState.savedAuditions = draftState.savedAuditions.filter(col => col.id !== payload);
                draftState.deletingSavedCollection = false;
            });
        case types.DELETE_SAVED_COLLECTION_FAIL:
            return produce(state, (draftState: typeof initialState) => {
                draftState.deletingSavedCollection = false;
            });
        case types.UPDATE_SAVED_COLLECTION:
            return produce(state, (draftState: any) => {
                draftState.updatingSavedCollection = true;
            });
        case (types.UPDATE_SAVED_COLLECTION_SUCCESS, types.UPDATE_SAVED_COLLECTION_FAIL):
            return produce(state, (draftState: any) => {
                draftState.updatingSavedCollection = false;
            });
        case types.CREATE_AUDITION:
            return produce(state, draftState => {
                draftState.creatingAuditionMode = true;
                draftState.creatingInProcess = true;
                if (payload && 'brandCuratedInviteUserIds' in payload && Array.isArray(payload.brandCuratedInviteUserIds)) {
                    const ids: string[] = payload.brandCuratedInviteUserIds
                        .map((x: unknown) => String(x).trim())
                        .filter((s: string): s is string => Boolean(s));
                    draftState.pendingBrandCuratedInviteUserIds = [...new Set(ids)];
                }
            });
        case types.UPDATE_AUDITION:
            return produce(state, draftState => {
                const { imageCover, tempImageCover } = payload.body || {};
                draftState.updatingAudition = true;
                if (imageCover && tempImageCover && draftState.managedAuditionWithSubmissions) {
                    draftState.managedAuditionWithSubmissions['prevImageCover'] =
                        draftState.managedAuditionWithSubmissions.imageCover;
                    draftState.managedAuditionWithSubmissions.imageCover = tempImageCover;
                }
            });
        case types.PUBLISH_AUDITION_SUCCESS:
            return produce(state, (draftState: typeof initialState) => {
                draftState.currentAuditionInCreation = payload;
                draftState.creatingInProcess = false;
                draftState.unPublishing = false;
                if (draftState.managedAuditionWithSubmissions) {
                    draftState.managedAuditionWithSubmissions.status = payload.status;
                }
                if (Array.isArray(draftState.auditions)) draftState.auditions.unshift(payload);
            });
        case types.CREATE_AUDITION_SUCCESS:
        case types.UNPUBLISH_AUDITION_SUCCESS:
            return produce(state, (draftState: typeof initialState) => {
                draftState.currentAuditionInCreation = payload;
                draftState.creatingInProcess = false;
                draftState.unPublishing = false;
                if (type === types.CREATE_AUDITION_SUCCESS) {
                    draftState.pendingBrandCuratedInviteUserIds = [];
                }
                if (draftState.managedAuditionWithSubmissions) {
                    draftState.managedAuditionWithSubmissions.status = payload.status;
                }
            });
        case types.UPDATE_AUDITION_SUCCESS:
            return produce(state, (draftState: typeof initialState) => {
                if (draftState.managedAuditionWithSubmissions) {
                    draftState.managedAuditionWithSubmissions['prevImageCover'] = undefined;
                    draftState.updatingAudition = false;
                    const payloadClone: IAudition = payload as IAudition;
                    /** Check for roles && applications */
                    (Object.keys(payloadClone) as Array<keyof IAudition>).forEach(key => {
                        if (
                            draftState.managedAuditionWithSubmissions &&
                            !_.isEqual(draftState.managedAuditionWithSubmissions[key], payloadClone[key]) &&
                            key !== 'applications'
                        ) {
                            // Type assertion to ensure type safety
                            (draftState.managedAuditionWithSubmissions[key] as any) = payloadClone[key];
                        }
                    });
                }
            });

        case types.UPDATE_AUDITION_FAIL:
            return produce(state, (draftState: typeof initialState) => {
                draftState.updatingAudition = false;
                if (
                    draftState.managedAuditionWithSubmissions &&
                    draftState.managedAuditionWithSubmissions['prevImageCover']
                ) {
                    draftState.managedAuditionWithSubmissions.imageCover =
                        draftState.managedAuditionWithSubmissions['prevImageCover'];
                    draftState.managedAuditionWithSubmissions['prevImageCover'] = undefined;
                }
            });
        case types.CREATE_AUDITION_FAIL:
            return produce(state, (draftState: typeof initialState) => {
                draftState.creatingAuditionError = payload;
                draftState.creatingInProcess = false;
            });
        case types.CREATE_ROLE:
            return produce(state, (draftState: typeof initialState) => {
                draftState.creatingInProcess = true;
            });
        case types.CREATE_ROLE_SUCCESS:
            return produce(state, (draftState: typeof initialState) => {
                draftState.creatingInProcess = false;
                const newItem: any = [...draftState.currentAuditionRolesInCreation, payload];
                draftState.currentAuditionRolesInCreation = newItem;
                draftState.currentAuditionInCreation.roles = newItem;

                // Update managedAuditionWithSubmissions if it exists
                if (draftState.managedAuditionWithSubmissions) {
                    draftState.managedAuditionWithSubmissions.roles = [
                        ...draftState.managedAuditionWithSubmissions.roles,
                        payload,
                    ];
                }
            });
        case types.CREATE_ROLE_FAIL:
            return produce(state, (draftState: typeof initialState) => {
                draftState.creatingInProcess = false;
                draftState.creatingRolesError = payload;
            });
        case types.PUBLISH_AUDITION:
            return produce(state, (draftState: typeof initialState) => {
                draftState.creatingInProcess = true;
            });
        case types.PUBLISH_AUDITION_FAIL:
            return produce(state, (draftState: typeof initialState) => {
                draftState.creatingInProcess = false;
                draftState.creatingAuditionError = payload;
            });
        case types.UNPUBLISH_AUDITION:
            return produce(state, (draftState: typeof initialState) => {
                draftState.unPublishing = true;
            });
        case types.DELETE_AUDITION:
            return produce(state, (draftState: typeof initialState) => {
                draftState.deletingAudition = true;
            });
        case types.DELETE_AUDITION_SUCCESS:
            return produce(state, (draftState: typeof initialState) => {
                draftState.deletingAudition = false;
                const deletedId = String(payload);
                draftState.auditions = (draftState.auditions || []).filter(
                    (a: any) => a && String(a._id) !== deletedId && String(a.id) !== deletedId,
                );
                const managed = draftState.managedAuditionWithSubmissions as any;
                if (
                    managed &&
                    (String(managed._id) === deletedId ||
                        String(managed.id) === deletedId ||
                        (managed.slug && String(managed.slug) === deletedId))
                ) {
                    draftState.managedAuditionWithSubmissions = null;
                    draftState.currentManagedApplications = [];
                }
            });
        case types.DELETE_AUDITION_FAIL:
            return produce(state, (draftState: typeof initialState) => {
                draftState.deletingAudition = false;
                draftState.deletingAuditionErrorMsg = payload;
            });
        case types.UPLOAD_PROGRESS:
            return produce(state, (draftState: typeof initialState) => {
                draftState.uploadProgress = payload;
            });
        case types.SET_AUDITION_FOR_EDIT:
            return produce(state, (draftState: typeof initialState) => {
                draftState.currentAuditionInCreation = payload;
                draftState.currentAuditionRolesInCreation = payload.roles;
            });
        case types.DELETE_ROLE:
            return produce(state, (draftState: typeof initialState) => {
                if (draftState.managedAuditionWithSubmissions) {
                    const currentRoles = draftState.managedAuditionWithSubmissions.roles;
                    /** The the roles that is being managed */
                    draftState.currentManagedRoles = currentRoles;
                    const updatedRoles = currentRoles.filter(roles => roles._id !== payload);
                    draftState.managedAuditionWithSubmissions.roles = updatedRoles;
                }
            });
        case types.DELETE_ROLE_SUCCESS:
            return produce(state, (draftState: typeof initialState) => {
                /** The the roles that is being managed */
                draftState.currentManagedRoles = undefined;
            });
        case types.DELETE_ROLE_FAIL:
            return produce(state, (draftState: typeof initialState) => {
                if (draftState.managedAuditionWithSubmissions && draftState.currentManagedRoles) {
                    draftState.managedAuditionWithSubmissions.roles = draftState.currentManagedRoles;
                }
            });
        case types.SET_AUDITION_TO_MANAGE:
            return produce(state, (draftState: typeof initialState) => {
                draftState.currentManagedAudition = payload;
            });
        case types.SET_APPLICATIONS_TO_MANAGE:
            return produce(state, (draftState: typeof initialState) => {
                draftState.sorter = {
                    invited: [],
                    unfiled: [],
                    yes: [],
                    no: [],
                    cast: [],
                    archived: [],
                };
                const parsedApplication = payload;
                draftState.currentManagedApplications = parsedApplication as any;
                parsedApplication.forEach((application: IApplication) => {
                    draftState.sorter[application.filing_status] = [
                        ...draftState.sorter[application.filing_status],
                        application,
                    ];
                });
            });
        case types.GET_ALL_APPLICATION_FOR_AUDITION:
            return produce(state, (draftState: typeof initialState) => {
                draftState.gettingAuditionApplications = true;
                draftState.sorter = {
                    invited: [],
                    unfiled: [],
                    yes: [],
                    no: [],
                    cast: [],
                    archived: [],
                };
            });
        case types.GET_ALL_APPLICATION_FOR_AUDITION_SUCCESS:
            return produce(state, (draftState: typeof initialState) => {
                const parsedApplication = payload;
                draftState.currentManagedApplications = parsedApplication as any;
                parsedApplication.forEach((application: IApplication) => {
                    draftState.sorter[application.filing_status] = [
                        ...draftState.sorter[application.filing_status],
                        application,
                    ];
                });
                draftState.gettingAuditionApplications = false;
            });
        case types.GET_ALL_APPLICATION_FOR_AUDITION_FAIL:
            return produce(state, (draftState: typeof initialState) => {
                draftState.gettingAuditionApplications = false;
            });
        case types.SORT_APPLICATION:
            return produce(state, (draftState: typeof initialState) => {
                draftState.sortingApplication = true;
            });
        case types.SORT_APPLICATION_SUCCESS:
            return produce(state, (draftState: typeof initialState) => {
                const { _id } = payload;
                /** Replace the value inside the managedAPplications */
                const currentIndex = draftState.currentManagedApplications.findIndex(
                    (value: IApplication) => value._id === _id,
                );
                let body: any = {};
                if (currentIndex > -1) {
                    const currentApplication = draftState.currentManagedApplications[currentIndex];
                    body = {
                        ...currentApplication,
                        filing_status: payload.filing_status,
                    };
                    draftState.currentManagedApplications[currentIndex] = body;
                }
                const currentApplicationsClone: any = [...draftState.currentManagedApplications];
                const newFilingStatus = payload.filing_status as
                    | 'invited'
                    | 'unfiled'
                    | 'yes'
                    | 'no'
                    | 'cast'
                    | 'archived';

                currentApplicationsClone.forEach((application: IApplication) => {
                    draftState.sorter[application.filing_status] = [
                        ...draftState.sorter[application.filing_status],
                        application,
                    ];
                });

                /** Filter out the current application */
                draftState.sorter = {
                    invited: draftState.sorter.invited.filter(app => app._id !== _id),
                    unfiled: draftState.sorter.unfiled.filter(app => app._id !== _id),
                    yes: draftState.sorter.yes.filter(app => app._id !== _id),
                    no: draftState.sorter.no.filter(app => app._id !== _id),
                    cast: draftState.sorter.cast.filter(app => app._id !== _id),
                    archived: draftState.sorter.archived.filter(app => app._id !== _id),
                };

                /** Push the application into the sort */
                if (newFilingStatus in draftState.sorter) {
                    draftState.sorter[newFilingStatus].push(body);
                }

                draftState.sortingApplication = false;
            });
        case types.SORT_APPLICATION_FAIL:
            return produce(state, (draftState: typeof initialState) => {
                draftState.sortingApplication = false;
            });
        case types.SET_AUDITION_DETAILS:
            return produce(state, (draftState: typeof initialState) => {
                draftState.auditionDetails = payload;
                draftState.gettingAudtionDetails = false;
            });
        case types.LOAD_MORE_AUDITIONS:
            return produce(state, draftState => {
                draftState.loadingMore = true;
            });
        case types.LOAD_MORE_AUDITIONS_SUCCESS:
            return produce(state, draftState => {
                const { data, query } = payload as ILoadMoreResponse;
                draftState.loadingMore = false;
                const parsedAuditions = parseAuditions(data, draftState.applications);
                draftState.auditions = [...draftState.auditions, ...parsedAuditions];
                draftState.currentAuditionLimit = query.limit;
                draftState.currentAuditionPage = query.page;
            });
        case types.LOAD_MORE_AUDITIONS_FAIL:
            return produce(state, draftState => {
                draftState.loadingMore = false;
                draftState.loadingMoreErr = payload;
            });
        case types.WITHDRAW_APPLICATION:
            return produce(state, draftState => {
                draftState.withdrawingApplication = true;
            });
        case types.WITHDRAW_APPLICATION_SUCCESS:
            const { applicationId } = payload as IWithdrawApplication;
            return produce(state, draftState => {
                draftState.applications = draftState.applications.filter(
                    application => application.id !== applicationId,
                );
                draftState.withdrawingApplication = false;
            });
        case types.WITHDRAW_APPLICATION_FAIL:
            return produce(state, draftState => {
                draftState.withdrawApplicationError = payload;
                draftState.withdrawingApplication = false;
            });
        case types.GET_SIMILAR_AUDITION:
            return produce(state, draftState => {
                draftState.gettingSimilarAuditions = true;
            });
        case types.GET_SIMILAR_AUDITION_SUCCESS:
            return produce(state, draftState => {
                draftState.similarAuditions = payload;
                draftState.gettingSimilarAuditions = false;
            });
        case types.GET_SIMILAR_AUDITION_FAIL:
            return produce(state, draftState => {
                draftState.gettingSimilarAuditions = false;
                draftState.gettingAuditionError = payload;
            });
        case types.GET_CASTING_DIRECTOR:
            return produce(state, draftState => {
                draftState.gettingCastingDirector = true;
            });
        case types.GET_CASTING_DIRECTOR_SUCCESS:
            return produce(state, draftState => {
                draftState.castingDirector = normalizeCastingDirectorList(payload);
                draftState.gettingCastingDirector = false;
            });
        case types.GET_CASTING_DIRECTOR_FAIL:
            return produce(state, draftState => {
                draftState.gettingCastingDirector = false;
            });
        case types.CREATE_CASTING_DIRECTOR:
            return produce(state, draftState => {
                draftState.creatingCastingDirector = true;
            });
        case types.CREATE_CASTING_DIRECTOR_FAIL:
            return produce(state, draftState => {
                draftState.creatingCastingDirector = false;
            });
        case types.CREATE_CASTING_DIRECTOR_SUCCESS:
            return produce(state, draftState => {
                const created = normalizeCastingDirectorRecord(payload);
                if (created) {
                    draftState.castingDirector?.unshift(created);
                }
                draftState.creatingCastingDirector = false;
            });
        case types.UPDATE_CASTING_DIRECTOR_SUCCESS:
            return produce(state, draftState => {
                const updated = normalizeCastingDirectorRecord(payload);
                if (!updated || !Array.isArray(draftState.castingDirector)) return;
                const idx = draftState.castingDirector.findIndex((c: any) => c && String(c._id) === updated._id);
                if (idx >= 0) {
                    draftState.castingDirector[idx] = { ...draftState.castingDirector[idx], ...updated };
                } else {
                    draftState.castingDirector.unshift(updated);
                }
            });
        case types.SET_ROLE:
            return produce(state, draftState => {
                draftState.selectedRole = payload;
            });
        case types.MANAGE_AUDITION:
            return produce(state, draftState => {
                const { isSearch, roleId, search, sort, page, status } = payload as IManageAuditionParams;
                draftState.managingAuditionWithSubmissionsError = null;
                // For a fresh detail load, clear previous managed audition so stale content never flashes.
                if (!isSearch && isEmpty(search) && !roleId && Number(page) < 2 && !status) {
                    draftState.managingAuditionWithSubmissions = true;
                    draftState.managedAuditionWithSubmissions = null;
                    draftState.currentManagedApplications = [];
                }

                if (roleId || isSearch || sort || Number(page) > 1 || status) {
                    draftState.searching = true;
                }
            });

        case types.MANAGE_AUDITION_SUCCESS:
            return produce(state, draftState => {
                draftState.managingAuditionWithSubmissions = false;
                draftState.managedAuditionWithSubmissions = action.payload.data.audition;
                draftState.currentManagedApplications = action.payload.data.applications;
                draftState.managedAuditionPagination = action.payload.data.pagination;
                draftState.searching = false;
                draftState.managingAuditionWithSubmissionsError = null;
            });
        case types.MANAGE_AUDITION_FAIL:
            return produce(state, draftState => {
                draftState.managingAuditionWithSubmissions = false;
                draftState.managingAuditionWithSubmissionsError = action.payload;
                draftState.searching = false;
            });
        case types.RESET_AUDTION_DATA:
            return restoreInitialState(state, initialState);
        case types.UPDATE_ROLE_SUCCESS:
            return produce(state, (draftState: typeof initialState) => {
                // Update managedAuditionWithSubmissions if it exists
                if (draftState.managedAuditionWithSubmissions) {
                    const roleIndex = draftState.managedAuditionWithSubmissions.roles.findIndex(
                        (role: any) => role._id === payload._id,
                    );
                    if (roleIndex !== -1) {
                        draftState.managedAuditionWithSubmissions.roles[roleIndex] = payload;
                    }
                }
            });
        default:
            return state;
    }
};

export { reducer };
